import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';
import { cn } from '@/lib/utils';

interface OfferTimerProps {
  endSec?: number;
  label: string;
  className?: string;
}

export function OfferTimer({ endSec, label, className }: OfferTimerProps) {
  // Mock: começar com 10 minutos para demonstração
  const [seconds, setSeconds] = useState(600);

  useEffect(() => {
    if (!endSec) return;

    const interval = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [endSec]);

  const formatTime = (totalSeconds: number): string => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const getColorClass = () => {
    if (seconds < 60) return 'text-red-600 dark:text-red-400';
    if (seconds < 300) return 'text-orange-600 dark:text-orange-400';
    return 'text-foreground';
  };

  return (
    <div className={cn('flex items-center justify-center gap-2 p-3 rounded-lg bg-muted/50', className)}>
      <Clock className={cn('h-5 w-5', getColorClass())} />
      <div className="text-center">
        <p className="text-xs text-muted-foreground">{label}</p>
        <p className={cn('text-2xl font-bold tabular-nums', getColorClass())}>
          {formatTime(seconds)}
        </p>
      </div>
    </div>
  );
}
